import React, { useState, useEffect, useRef } from "react";
import { Images } from "../../assets/assets";

import PrimaryButton from "../../components/Button/PrimaryButton";

import Footer from "../../components/Footer/Footer";
import { Link,  } from "react-router-dom";
import Swiper from "../../components/Swiper/Swiper";

import { BlogsService } from "../../APIs";
import { Helmet } from "react-helmet";

import RecommendationItem from "../../components/RecommendationItem/RecommendationItem";

import "react-toastify/dist/ReactToastify.css";
import "./style.css";
import HomeSlider from "../../components/Slider/HomeSlider";

import { BiChevronRight } from "react-icons/bi";

const partners = [
  {
    id: 1,
    src: "http://res.cloudinary.com/brabenjos/image/upload/v1730659003/sodastream/1730659003377.png",
    alt: "Partner 1",
  },
  {
    id: 2,
    src: "http://res.cloudinary.com/brabenjos/image/upload/v1724930135/sodastream/1724930135427.png",
    alt: "Partner 2",
  },
  {
    id: 3,
    src: "http://res.cloudinary.com/brabenjos/image/upload/v1724930187/sodastream/1724930187510.png",
    alt: "Partner 3",
  },
  {
    id: 4,
    src: "http://res.cloudinary.com/brabenjos/image/upload/v1724930236/sodastream/1724930236717.png",
    alt: "Partner 4",
  },
];

const slides = [
 
  {
    // image: Images.HomeBG1,

    image:
      "http://res.cloudinary.com/brabenjos/image/upload/v1754661132/sodastream/1754661131906.png",
    title: "MEET GAIA ",
    description: "Everyday Sparkle. Zero Fuss.",
    buttonLabel: "Meet GAIA",
    link: "/water-makers/gaia-sparkling-water-maker",
  },
  {
    image:
      "http://res.cloudinary.com/brabenjos/image/upload/v1749404812/sodastream/1749404812830.png",

    title: "ENSO Experience ",
    description: "the ultimate SodaStream creation ",
    buttonLabel: "Explore Enso",
    link: "/water-makers/enso-sparkling-water-maker",
  },
];

const HomePage = () => {
  const [screenSize, setScreenSize] = useState(getCurrentDimension());

  function getCurrentDimension() {
    return {
      width: window.innerWidth,
      height: window.innerHeight,
    };
  }

  useEffect(() => {
    const updateDimension = () => {
      setScreenSize(getCurrentDimension());
    };
    window.addEventListener("resize", updateDimension);

    return () => {
      window.removeEventListener("resize", updateDimension);
    };
  }, [screenSize]);

  const [blogs, setBlogs] = useState<any[]>([]);

  const fetchBlogsData = async () => {
    try {
      const response = await BlogsService.getAllBlogs();
      if (response.data) {
        setBlogs(response.data);
      } else {
        console.error("Error fetching blogs:", response.error);
      }
    } catch (error) {
      console.error("Error fetching :");
    }
  };

  function toUrlSlug(text: string) {
    const decoded = decodeURIComponent(text);
    const hyphenated = decoded.replace(/\s+/g, "-");
    return hyphenated;
  }

  useEffect(() => {
    fetchBlogsData();
  }, []);

  const videoRef = useRef<HTMLVideoElement | null>(null);

  const iframeRef = useRef<HTMLIFrameElement | null>(null);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://player.vimeo.com/api/player.js";
    script.async = true;
    document.body.appendChild(script);

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && iframeRef.current) {
            iframeRef.current.src =
              "https://player.vimeo.com/video/1022254175?badge=0&autopause=0&player_id=0&app_id=58479&autoplay=1&background=1";
          }
        });
      },
      { threshold: 0.5 }
    );

    if (iframeRef.current) {
      observer.observe(iframeRef.current.parentElement!);
    }

    return () => {
      document.body.removeChild(script);
      if (iframeRef.current) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        observer.unobserve(iframeRef.current.parentElement!);
      }
    };
  }, []);

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          {
            "SodaStream Official SA Store: Sparkling Water Makers & Gas Cylinders"
          }
        </title>

        <meta
          name="description"
          content={
            "SodaStream is the first choice for Home Water Carbonation System in South Africa. Checkout our range of Sparkling water machines/makers, bottles and flavours."
          }
        />
        <link rel="canonical" href="https://www.sodastream.co.za/" />
        <meta
          name="keywords"
          content="home water carbonation system,
           home water carbonation system south africa, sparkling water machine for home"
        />

        <meta name="avg-search-volume" content="10 10 40" />

        <meta
          name="search-intent"
          content="Informational, Commercial, Commercial"
        />
      </Helmet>

      <div className="mt-[105px] md:mt-0">
        <HomeSlider slides={slides} screenSize={screenSize} />
      </div>

      <section className="bg-[#75A7AD] md:h-[340px] mt-0 ">
        <div className="flex gap-14 md:px-15 p-5 text-start items-center">
          <div className="flex-col flex gap-2">
            <p className="text-[#F9C645] md:text-[60px] text-[18px] mt-0 mb-0">
              Running low on pshh-pshh?
            </p>
            <p className="text-white md:text-[35px] text-[15px] mb-[5px]">
              Buy gas at your favourite retailer.
            </p>

            <div className="mt-[20px] mb-[20px] rounded-[16px] w-full ml-[5px] md:ml-[-30px]">
              <div className="grid grid-cols-4 gap-x-5 gap-y-5">
                {partners.map((partner) => (
                  <div
                    key={partner.id}
                    className="flex justify-center items-center z-[9] relative">
                    <img
                      className="w-[75px] h-auto object-cover md:w-[110px]"
                      src={partner.src}
                      alt={partner.alt}
                    />
                  </div>
                ))}
              </div>
            </div>

            <Link to="/store-locator">
              <PrimaryButton label="STORE LOCATOR" />
            </Link>
          </div>
          <div>
            <div className="md:max-w-[350px] md:block hidden">
              <img
                src={Images.WatterBottles}
                width="100%"
                height="100%"
                alt="water bottles"
              />
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="flex gap-0 flex-wrap md:flex-nowrap">
          <div className="basis-[100%] md:basis-[50%] relative bg-[#75A7AD] w-full">
            <div className="md:absolute t-0 left-0">
              <img src={Images.ArtImg} alt="art" className="hidden md:block" />
              <div className="p-5 py-10">
                <p className="text-[#E56C5C] md:text-[30px] text-[14px] text-start mb-2">
                  Sparkling Water Makers
                </p>
                <Link to="/water-makers">
                  <PrimaryButton label="Explore ART" />
                </Link>
              </div>
            </div>
            <div>
              <img
                className="absolute bottom-0 right-[0] w-[30%] md:w-[25%] md:block"
                src={Images.WatterBottleBlack2}
                alt="water bottle black"
              />
            </div>
            <div>
              <img
                className="absolute bottom-0 right-20 w-[22%] md:w-[30%] hidden md:block"
                src={Images.Glass}
                alt="water bottle black"
              />
            </div>
          </div>

          <div className="flex-grow bg-[#005D6E]">
            <div className="md:py-20 md:px-20 p-5 flex flex-col gap-5">
              <div className="flex flex-wrap gap-10 text-white w-full justify-between">
                <p className="text-[#F9C645] text-[24px]">Co2 Gas Cylinders</p>
                <div className="flex gap-4 mt-[-50px] md:mt-[-30px]">
                  <Link
                    to="/refill"
                    className="text-white hover:underline flex items-center">
                    Exchange
                    <BiChevronRight className="ml-1" fontSize={22} />
                  </Link>
                  <Link
                    to="/spare"
                    className="text-white hover:underline flex items-center">
                    Spare
                    <BiChevronRight className="ml-1" fontSize={22} />
                  </Link>
                </div>
              </div>
              <Link to="co2-gas-cylinders">
                <PrimaryButton label="Explore Cylinders" />
              </Link>
            </div>

            <div className={`h-[316px] relative md:block hidden`}>
              <img
                src={Images.GasTextImg}
                alt="gas"
                className="hidden md:block"
              />
              <img
                className="absolute bottom-0 right-16 hidden md:block"
                src={Images.ColoredWatterBottle}
                alt="SodaStream Bottles"
                style={{ height: "90%" }}
              />
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="relative w-full min-h-[600px] bg-[#EEEAE5]">
          <div
            className="absolute inset-0 bg-cover bg-center "
            style={{
              backgroundImage: `url(${Images.FlavourTxt})`,
              backgroundSize: "80%",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          />
          <div className="absolute top-0 hidden md:block ">
            <img
              src={Images.DeepBlueSodastreamRipple}
              style={{ width: "60%" }}
              alt="Deep Blue Soda Stream"
            />
          </div>
          <div
            className="absolute top-1/2 flex flex-col gap-5 md:flex-row w-full md:px-20 px-10"
            style={{ transform: "translateY(-50%)" }}>
            <div
              className="text-start flex flex-col gap-2 basis-[50%] ml-[0px] 
              mt-[20px]
             md:mt-[80px] ml- md:ml-[50px]">
              <p className="text-[#75A7AD] md:ml-[60px] font-bold text-[25px] text-center">
                One SodaStream.
              </p>
              <p className="text-[#E56C5C] md:ml-[60px] font-bold text-[24px] text-center">
                Endless possibilities.
              </p>
              <div className="flex justify-center md:ml-[60px]">
                <Link to="/flavours">
                  <PrimaryButton label="SHOP ALL" />
                </Link>
              </div>
            </div>
            {/* //TODO: make it bigger on mobile screen instead of hidding them */}
            <div className="md:basis-[100%]">
              <Swiper
                images={[
                  { src: Images.Prod7Up, alt: "" },
                  { src: Images.ProdExtremeEnergy, alt: "" },
                  { src: Images.ProdPepsiMax, alt: "" },
                  { src: Images.ProdGingerBeer, alt: "" },
                  { src: Images.ProdPepsi, alt: "" },
                  { src: Images.ProdMiranda, alt: "" },
                  { src: Images.ProdIceTeaPeach, alt: "" },
                  { src: Images.ProdTonic3, alt: "" },
                  { src: Images.ProdClassicsCreamSoda, alt: "" },
                  { src: Images.ProdLemonade, alt: "" },
                ]}
              />
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="flex gap-0 flex-wrap md:flex-nowrap">
          <div className="md:basis-[50%] md:block hidden flex-grow">
            <img
              className="h-full"
              src={Images.PouringFromFuseBottle}
              alt="bg"
              width={"100%"}
              height={"100%"}
            />
          </div>

          {/*  */}
          <div className="bg-[#75A7AD] p-20 md:basis-[50%] w-full flex flex-col items-start gap-4">
            <h2 className="text-[#F9C645] text-[22px]">Bottles</h2>
            <p className="text-white">Everything you need to know.</p>
            <Link to="/accessories">
              <PrimaryButton label="EXPLORE NOW" />
            </Link>
          </div>
        </div>
      </section>

      <section>
        <div className="relative h-auto md:h-[400px] w-full bg-[#EEEAE5] p-20 md:px-40 px-10 flex flex-col-reverse md:flex-row justify-between items-center">
          <div className="md:basis-[50%] basis-[100%]">
            <div className="flex flex-col gap-4 items-start justify-center text-start md:w-2/3">
              <p className="text-[#A0BA86] text-[20px]">
                One SodaStream can save up to thousands of single use plastic
                bottles.
              </p>
              <p className="text-[#707070]">
                If I use a SodaStream Sparkling Water Maker, I will save in a
                month ~ 71 plastic bottles
              </p>
              <Link to={"/why-sodastream"}>
                <PrimaryButton label="MORE INFO" />
              </Link>
            </div>
          </div>

          <div className="md:basis-[40%] basis-[100%] breathing-heart">
            <img
              src={Images.GroupedSodaStreamRipple}
              alt="SodaStream - My only water"
              style={{ width: "100%" }}
            />
          </div>
        </div>
      </section>

      <section className="hero-video-section">
        <video
          autoPlay
          muted
          loop
          playsInline
          ref={videoRef}
          src="https://ik.imagekit.io/we1qa1aly/sodastream.mp4?updatedAt=1729355317582"
        />
      </section>

      <section>
        <div className="bg-[#EEEAE5] px-5 md:px-20 py-10 flex flex-col gap-4">
          <h2 className="text-[20px] text-[#005D6E] text-center font font-bold ">
            CHANGING THE WAY
          </h2>
          <p className="text-[#E56C5C] text-[25px] text-center font font-bold">
            MZANSI DRINKS
          </p>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-10">
            {blogs.map((recommendation, index) => (
              <Link
                to={`/blog/${toUrlSlug(recommendation.bloglink)}`}
                key={index}
                className="col-span-1">
                <RecommendationItem
                  image={recommendation.image}
                  title={recommendation.title}
                  subTitle={recommendation.subTitle}
                />
              </Link>
            ))}
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default HomePage;
